import BaseValidator from '../../../utils/BaseValidator';
import InputTypes from '../../../enums/InputTypes';
import { isEmpty } from '../../../utils/ValidForm';

export default class BaseConfigForm extends BaseValidator {
    campos = [];
    initialValues = {};
    hasChangeInputs = false;
    #id = null;
    #countClick = 0;

    constructor(inputs) {
        super(inputs);
        this.campos = [];
        this.initialValues = inputs
            .filter((el) => el?.form?.use)
            .reduce(function (prev, curr) {
                prev[curr?.name] =
                    curr?.form?.initialValue === undefined ? '' : curr?.form?.initialValue;
                return prev;
            }, {});
    }
    setCountClick(val) {
        this.#countClick = val;
    }
    addCountClick() {
        this.#countClick++;
    }
    getCountClick() {
        return this.#countClick;
    }
    setId(id) {
        this.#id = id;
    }
    getId() {
        return this.#id;
    }
    setInitialValue(field, value) {
        this.initialValues[field] = value;
    }
    setInitialValues(values) {
        this.initialValues = values;
    }
    setRequired(field, value) {
        const input = this.inputs.find((el) => el?.name === field);
        if (input) {
            input.form.validate = { ...input.form.validate, required: value };
            this.setInputs([...this.inputs.filter((el) => el?.name !== field), input]);
        }
    }
    isNew() {
        return !this.getId() || this.getId() === '0';
    }
    isView() {
        return `${window.location.pathname}`.includes('/view');
    }
    validate(data) {
        let errors = {};
        if (this.getCountClick() > 0) {
            errors = this.valid(data);
            errors = this.customValidate(data, errors);
        }
        return errors;
    }
    customValidate(data, errors) {
        return errors;
    }

    static hasChanged(initialFormik, values, inputs = [], ignoreInputs = []) {
        const ajustaNumber = (val) => {
            if (val === 0 || val === undefined || val === '' || val === null) {
                return null;
            }
            return val;
        };

        if (!initialFormik?.afterBaseFormLoaded) {
            return false;
        }

        let thisChanged = {};

        for (let i = 0; i < inputs.length; i++) {
            const input = inputs[i];

            if (ignoreInputs.find((inputIgnore) => inputIgnore === input.name)) {
                continue;
            }

            switch (input?.type) {
                case InputTypes.ARRAY:
                    const valorAtual = values[input.name] ?? [];
                    const valorInitialAtual = initialFormik[input.name] ?? [];

                    if (valorInitialAtual.length !== valorAtual.length) {
                        thisChanged = {
                            input,
                            diff: 'length',
                            valorInitial: valorInitialAtual,
                            valorAtual,
                        };
                        return { hasChange: true, thisChanged };
                    }

                    for (let x = 0; x < valorAtual.length; x++) {
                        const thisValue = valorAtual[x];
                        const thisInitialValue = valorInitialAtual[x];
                        if (
                            typeof thisValue === 'string' ||
                            typeof thisValue === 'boolean' ||
                            typeof thisValue === 'number'
                        ) {
                            if (thisValue !== thisInitialValue) {
                                thisChanged = {
                                    input,
                                    diff: {
                                        val1: thisValue,
                                        val2: thisInitialValue,
                                        isStringfy: false,
                                    },
                                };
                                return { hasChange: true, thisChanged };
                            }
                        } else if (JSON.stringify(thisValue) !== JSON.stringify(thisInitialValue)) {
                            thisChanged = {
                                input,
                                diff: { val1: thisValue, val2: thisInitialValue, isStringfy: true },
                            };
                            return { hasChange: true, thisChanged };
                        }
                    }
                    break;
                case InputTypes.INTEGER:
                case InputTypes.FLOAT:
                case InputTypes.DOUBLE:
                    if (
                        ajustaNumber(initialFormik[input.name]) !== ajustaNumber(values[input.name])
                    ) {
                        thisChanged = {
                            input,
                            diff: {
                                val1: ajustaNumber(initialFormik[input.name]),
                                val2: ajustaNumber(values[input.name]),
                            },
                        };

                        return { hasChange: true, thisChanged };
                    }
                    break;
                case InputTypes.ENTITY:
                    if (isEmpty(initialFormik[input.name]) && isEmpty(values[input.name])) continue;

                    if (
                        JSON.stringify(initialFormik[input.name]) !==
                        JSON.stringify(values[input.name])
                    ) {
                        thisChanged = {
                            input,
                            diff: {
                                val1: initialFormik[input.name],
                                val2: values[input.name],
                                isStringfy: true,
                            },
                        };
                        return { hasChange: true, thisChanged };
                    }
                    break;
                default:
                    if (initialFormik[input.name] !== values[input.name]) {
                        return { hasChange: true, thisChanged };
                    }
                    break;
            }
        }
        return { hasChange: false, thisChanged };
    }
}
